export default "__VITE_ASSET__BmUaRJ4P__"